export const routes = (prefix = `billing`) => [
    {
        path: `/${prefix}/approvals`,
        name: `${prefix}.approvals.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.approvals.index`,
                PageDescription: "Accounts - Approvals",
            },
        },
    },
    {
        path: `/${prefix}/approvals/cashout-print`,
        name: `${prefix}.approvals.cashout-print.index`,
        component: () => import('./prints/CashOut.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.approvals.index`,
                PageDescription: "Accounts - Approvals",
            },
        },
    },
];
